// extracted by mini-css-extract-plugin
export default {"list":"members_list__GIfwP"};